import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncionService } from '../../servicios/funcion.service';
import { User } from '../../utilidades/utilidades';
import { environment } from '../../../environments/environment.prod';

@Component({
	selector: 'app-detalle-pedido',
	templateUrl: './detalle-pedido.component.html',
	styleUrls: ['./detalle-pedido.component.css']
})
export class DetallePedidoComponent implements OnInit {

	newUser:User;
	newVenta:any = { detalle:[] };
	ultimoMovimiento:any = {};
	showModal:boolean = false;
	showHistorial:boolean = false;
	showCancelacion:boolean = false;


	listaMotivos:any = [{
		id:1,
		descripcion:"Mi pedido tardará en llegar.",
		seleccionado:false
	},{
		id:2,
		descripcion:"Ya no deseo el producto.",
		seleccionado:false
	},{
		id:3,
		descripcion:"El producto no cumple con mis espectativas.",
		seleccionado:false
	},{
		id:4,
		descripcion:"Otro motivo.",
		seleccionado:false
	}];

	constructor(
		private newFuncionService: FuncionService,
		private newActivatedRoute: ActivatedRoute, 
		private newRouter: Router,
		private newTitle: Title
		) { }

	ngOnInit(): void {
		this.newUser = this.newFuncionService.currentUserValue;

		this.newActivatedRoute.paramMap.subscribe( (newRouterParams:any) => {
			this.fncargarInformacion( newRouterParams.params.uuid );
		}).unsubscribe();
	}

	fncargarInformacion( newUuid ){
		this.newFuncionService.setNewMensaje("Cargando información de tu pedido");
		this.newFuncionService.fnInformacionPedido( { pedido:{ uuid:newUuid } } ).subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.newVenta = response.informacion;
				this.ultimoMovimiento = this.newVenta.historialEnvio.slice(-1).pop();
				this.newTitle.setTitle(`Detalle del pedido ${this.newVenta.folioCompra}`);
			}
		});
	}

	fnClassPedido(){
		if( this.newVenta.tipo === 1 ){
			return "pedido-pendiente"
		}else if( this.newVenta.tipo === 2 ){
			return "pedido-entregado"
		}else if( this.newVenta.tipo === 3 ){
			return "pedido-cancelado"
		}
	}

	fnMostrarHistorial(){
		this.showCancelacion = false;
		this.showHistorial = true;
		this.showModal = true;
	}

	fnMostrarCancelacion(){
		this.listaMotivos.forEach( (newItem:any)=>{
			newItem.seleccionado = false;
		});
		this.showHistorial = false;
		this.showCancelacion = true;
		this.showModal = true;
	}

	fnCerrarModal(){
		this.showModal = false;
	}

	fnSeleccionMotivo( newMotivo ){
		this.listaMotivos.forEach( (newItem:any)=>{
			newItem.seleccionado = false;
		});
		newMotivo.seleccionado = true;
	}

	fnEnviarCancelacion(){
		var motivo = this.listaMotivos.find( newItem => newItem.seleccionado === true );
		if( motivo ){
			this.fnCerrarModal();
			this.newFuncionService.setNewMensaje("Enviando solicitud de cancelación");
			this.newFuncionService.fnCancelarCuenta({ compra:{ id:this.newVenta.id, comentario:motivo.descripcion } }).subscribe( (response:any)=>{
				this.newFuncionService.setNewMensaje(null);
				if( response.success ){
					this.newFuncionService.setNewAlerta( environment.alerta.cancelacion.success );
					this.newRouter.navigate(['mi-cuenta', 'mis-pedidos']);
				}else{
					this.newFuncionService.setNewAlerta( environment.alerta.cancelacion.fail );
				}
			});
		}else{
			this.newFuncionService.setNewAlerta( environment.alerta.cancelacion.empty );
		}
	}

}
